import { Directive, ElementRef, Input, inject } from '@angular/core';
import { ThemeColors } from '../models/theme-colors';

@Directive({
  selector: '[simColor]',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false
})
export class ColorDirective {
  private readonly el = inject(ElementRef);

  @Input() set simColor(value: ThemeColors | string) {
    this.el.nativeElement.classList.forEach((el: any) => {
      if (el.includes('sim-color-')) {
        this.el.nativeElement.classList.remove(el);
      }
    });
    this.el.nativeElement.classList.add(`sim-color-${value}`);
  }
}
